/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/passwordStrength.scss';

import React, {PureComponent} from 'react';

import {getStrengthGauche} from '../../util/utils';

import {StrengthGauge} from '@dvrd/dvr-controls';

import classNames from 'classnames';

interface Props {
    value: string;
}

export default class PasswordStrength extends PureComponent<Props> {
    render = () => {
        const {value} = this.props,
            gauches = getStrengthGauche();
        const passed: number = gauches.reduce(
            (prev: number, current: StrengthGauge) => (current.validator(value) ? prev + 1 : prev),
            0
        );
        return (
            <div className='pass-meter'>
                <span className={classNames('pass-strength', passed > 0 && 'pass')} />
                <span className={classNames('pass-strength', passed > 1 && 'pass')} />
                <span className={classNames('pass-strength', passed > 2 && 'pass')} />
                <span className={classNames('pass-strength', passed > 3 && 'pass')} />
            </div>
        );
    };
}
